import * as React from 'react';

import type { InstructorsFilterContextValue } from './InstructorsFilterContext.types';

import { InstructorsFilterContext } from './InstructorsFilterProvider';

export function useInstructorsFilter(): InstructorsFilterContextValue {
  const context = React.useContext(InstructorsFilterContext);

  if (!context) {
    throw new Error(
      'useInstructorsFilter must be used within InstructorsFilterProvider'
    );
  }

  return context;
}
